import { useQuery } from '@tanstack/react-query'
import { createCommentsQueryOptions, CommentsQueryParams } from './commentsQueryOptions'
import { commentsToMap } from './commentsSelectors'
import type { BudgetComment } from '../types'

export function useCommentsMap(params: CommentsQueryParams) {
  return useQuery({
    ...createCommentsQueryOptions(params),
    select: (comments: BudgetComment[]) => {
      const sortedComments = [...comments].sort((a, b) => a.id - b.id)
      return commentsToMap(sortedComments)
    }
  })
}
